var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-services"},[(_vm.has_flights)?_c('flights',{attrs:{"flights":_vm.services.flights}}):_vm._e(),_c('hotels',{class:_vm.has_flights ? 'mt-4' : '',attrs:{"hotels":_vm.services.hotels,"supplements":_vm.services.travelSupplements}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }